import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { EType, fetchSendCode } from '../../repositories/validation-codes/v1/send-code';
import { ESendCodeStatus } from './types';
export function sendCode(_x, _x2) {
  return _sendCode.apply(this, arguments);
}
function _sendCode() {
  _sendCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dependencies, phone) {
    var httpApi, logger, sendCodeResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          httpApi = dependencies.httpApi, logger = dependencies.logger;
          _context.prev = 1;
          _context.next = 4;
          return fetchSendCode({
            httpApi: httpApi,
            parameters: {
              phone: phone,
              type: EType.AuthenticateCode
            },
            config: {
              requestConfig: {
                headers: [['Content-Type', 'application/json']]
              }
            }
          });
        case 4:
          sendCodeResponse = _context.sent;
          if (!(sendCodeResponse.statusCode !== 200)) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", {
            status: ESendCodeStatus.Failed,
            message: sendCodeResponse.response.message
          });
        case 7:
          return _context.abrupt("return", {
            status: ESendCodeStatus.Succeed,
            senderType: sendCodeResponse.response.senderType || null,
            secondsToRetry: sendCodeResponse.response.secondsToRetry || 60,
            timeStamp: new Date().getTime()
          });
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](1);
          logger.error(_context.t0, {
            domain: 'auth-widget.api.sendCode'
          });
          return _context.abrupt("return", {
            status: ESendCodeStatus.Failed,
            message: 'Произошла непредвиденная ошибка'
          });
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 10]]);
  }));
  return _sendCode.apply(this, arguments);
}